<template>
  <main class="main-content" id="topDom">
    <section class="section">
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text"> {{ $t("i18n.presys") }}</span>
        </li>
      </ul>
      <div class="banner">
        <div class="banner__content container-fluid">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ form.title }}</h1>
              <h1 class="banner__title --small">{{ form.titleTwo }}</h1>
              <p class="banner__text">{{ form.text }}</p>
            </div>
          </div>
        </div>
        <div class="banner__bg">
          <img :src="isMobile() ? form.bgImg : form.bgImg" />
        </div>
      </div>

      <div class="properties container-fluid">
        <div class="wp-block-columns">
          <div class="wp-block-column">
            <div class="properties-div">
              <span class="properties-text-title">{{ $t('i18n.APPLICATIONS') }}</span>
              <div class="g-block-wrapper">
                <ul>
                  <li v-for="(item, index) of form.applications" :key="index">{{ item }}</li>
                </ul>
              </div>
            </div>
            <div class="properties-div">
              <span class="properties-text-title">{{ $t('i18n.MAINFEATURES') }}</span>
              <div class="g-block-wrapper">
                <ul>
                  <li v-for="(item, index) of form.mainFeatures" :key="index">{{ item }}</li>
                </ul>
              </div>
            </div>
            <div class="properties-div">
              <span class="properties-text-title">{{ $t('i18n.OPTIONS') }}</span>
              <div class="g-block-wrapper">
                <ul>
                  <li v-for="(item, index) of form.options" :key="index">{{ item }}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="wp-block-column">
            <img :src="form.img" />
          </div>
        </div>

        <div class="row mt-6 mt-md-12">
          <div class="col-12">
            <div class="summary-table --mobile-full-width">
              <div class="summary-table__wrapper">
                <a target="_blank" class="download-link --small  --thumb ">
                  <div class="download-link__thumb">
                    <img :src="form.downloadImg"/>
                  </div>
                  <div class="download-link__content mr-2">
                    <h4 class="download-link__title">
                      {{ form.downloadTitle }}
                    </h4>
                    <p class="download-link__title">{{ form.downloadText }}</p>
                  </div>
                  <div class="ml-auto" style="display: flex">
                    <span class="badge download-link__download"  @click="download"> {{ $t('i18n.download') }}</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12 footer-btn">
            <button class="va-btn --big" @click="goPageHome">{{ $t('i18n.backPresys') }}</button>
            <button class="va-btn ml-auto" @click="goPageNext" v-show="$t('i18n.presysDetailList')[this.index + 1]">{{ $t('i18n.next') }}</button>
          </div>
        </div>
      </div>
    </section>


  </main>
</template>

<script>
import {downloadFile} from "../api/api";
export default {
  name: "presysDetail",
  data() {
    return {
      id: localStorage.getItem('currentId') || '',
      form: {},
      index: -1
    }
  },
  created() {
    if(this.$route.params.form) {
      this.id = this.$route.params.form.id
    } else {
      this.id = localStorage.getItem('currentId')
    }
    let data = this.$route.params.form;
    if (!data) {
      this.$t('i18n.presysDetailList').forEach((item, index) => {
        if (item.name === localStorage.getItem("presysName")) {
          this.index = index;
          this.form = item;
        }
      });
      localStorage.setItem(this.form.name, JSON.stringify(this.form));
    } else if (data && localStorage.getItem(data.name)) {
      this.form =  JSON.parse(localStorage.getItem(data.name));
      this.$t('i18n.presysDetailList').forEach((item, index) => {
        if (item.name === this.form.name) {
          this.index = index;
        }
      });
    } else {
      this.$t('i18n.presysDetailList').forEach((item, index) => {
        if (item.name === data.name) {
          this.form = item;
          this.index = index;
        }
      });
      localStorage.setItem(data.name, JSON.stringify(this.form));
    }
    localStorage.setItem('currentId', this.id)
    localStorage.setItem('presysName', this.form.name);
  },
  mounted () {
    this.goTop();
  },
  methods: {
    download() {
      if (!this.$store.state.isLogin) {
        this.$router.push("login");
      }
      downloadFile({ 
        // id: this.$route.params.form.id 
        id: this.id
      }, localStorage.getItem('token')).then(res => {
        if (res.data && res.data.code == '1') {
          // window.open("http://a34.madpay.com/" + res.data.data)
          window.open("https://www.jiashengvac.com/" + res.data.data)
          // window.open("http://admin.jiashengvac.com/" + res.data.data)
        } else if (res.data && res.data.code == '0') {
          Message({
            message: "暂无下载文件",
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
        } else {
          Message({
            message: res.data.msg,
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
          if (res.data.msg === "请重新登录") {
            this.$router.push("login")
          }
        }
      })
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    goPageHome() {
      this.$router.push("Presys")
    },
    goPageNext() {
      if (this.$t('i18n.presysDetailList')[this.index + 1]) {
        this.form = this.$t('i18n.presysDetailList')[this.index + 1];
        localStorage.setItem(this.form.name, JSON.stringify(this.form));
        localStorage.setItem('presysName', this.form.name);
        localStorage.setItem('currentId', this.form.id);
        this.id = localStorage.getItem('currentId')
        this.index++;
      }
      this.goTop();
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    }
  },
}
</script>

<style scoped>

img {
  max-width: 100%;
}
.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #FFFFFF;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner {
  width: 100%;
  height: 61rem;
  align-items: center;
  display: flex;
  background-image: url(../assets/imgs/ban_bg.png);
  background-size: cover; /* 保证背景图片覆盖元素并且不变形 */
  background-position: center; /* 将背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  padding: 0 18rem 0 28rem;
}
.banner__bg {
  /* position: absolute;
  width: 100%;
  height: 61rem; */
  
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  /* max-width: 100%; */

  display: block;
  width: 100%;
}

.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-weight: normal;
  font-size: 5rem;
  color: #FFFFFF;
  letter-spacing: -.084rem;
  line-height: 6rem;
  text-wrap: nowrap;
}
.banner__title.--small {
  font-size: 3.2rem;
  line-height: 5rem;
}

.banner__text {
  margin-top: 3rem;
  font-size: 2.2rem;
  color: #fff;
  letter-spacing: -.022rem;
  line-height: 3.3rem;
  padding-right: 2rem;
}


.properties {
  margin-top: 10rem;
  margin-bottom: 10rem;
  color: #800080;
  font-weight: normal;
  line-height: 3rem;
  font-size: 2.2rem;
}
.properties-div {
  margin-bottom: 2rem;
}
.properties-text-title {
  font-size: 3rem;
  display: block;
  margin-bottom: 2rem;
}
.properties-text {
  color: #000000;
  display: block;
}

.properties-text:before{
  content: "";
  width: 1rem;
  height: 1rem;
  display: inline-block;
  margin-top: -.4rem;
  margin-right: 1rem;
  background: transparent;
  border: .1rem solid #6C2188;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 1rem;
}

.wp-block-columns {
  display: flex;
  margin-bottom: 28px;
  flex-wrap: wrap;
}
.wp-block-columns .wp-block-column:first-child {
  padding-right: 2rem;
}
.wp-block-columns .wp-block-column {
  margin: 0 1.5rem!important;
}
.wp-block-columns .wp-block-column:last-child {
  padding-left: 2rem;
}

.summary-table {
  width: 100%;
  padding: 5rem;
  border: 0.1rem solid #e6e6e6;
  border-radius: 0.4rem;
}
.download-link.--small {
  height: 6rem;
}
.download-link {
  display: flex;
  width: 100%;
  align-items: center;
  min-height: 8rem;
  padding: 1rem 2rem 1rem 0;
  position: relative;
  cursor: pointer;
  border-bottom: 0.1rem solid #ededed;
  transition: all .2s ease-in-out;
}
.download-link__thumb {
  width: 7rem;
  height: 7rem;
  padding: 1rem;
  margin-right: 2rem;
  position: relative;
  border: 0.1rem solid #e6e6e6;
  background: #fff;
  border-radius: 0.4rem;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);
  transition: all .2s ease-in-out;
}
.download-link__thumb img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.download-link__content {
  display: block;
  align-items: center;
}
.download-link__title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #000;
  display: block;
  letter-spacing: -.018rem;
  line-height: 3rem;
  margin: 0;
}
.download-link__download {
  height: 4rem;
  width: 8rem;
  font-size: 1.6rem;
  font-weight: normal;
  color: #800080;
  letter-spacing: -.018rem;
  line-height: 3rem;
  margin-left: auto;
  position: relative;
  border: .1rem solid #e6e6e6;
  border-radius: 2rem;
}

.footer-btn {
  display: flex;
  margin-bottom: 6rem;
}
.va-btn {
  height: 5rem;
  width: 19rem;
  border: 2px solid #ededed;
  border-radius: 10%;
  background-color: white;
  color: #800080;
}

.g-block-wrapper ul li {
  padding-left: 3rem;
  position: relative;
  font-size: 1.6rem;
  color: #231815;
  letter-spacing: -.02rem;
  line-height: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 500;
}
.g-block-wrapper ul li:before {
  content: "";
  position: absolute;
  z-index: 2;
  left: 0;
  top: 1.5rem;
  width: .7rem;
  height: .7rem;
  margin-top: -.4rem;
  margin-right: 1rem;
  background: transparent;
  border: .1rem solid #6C2188;
  border-radius: 1rem;
}
@media (max-width: 1023.9px) {
  .summary-table {
    padding: 3rem;
    overflow: auto;
    width: calc(100% + 3rem);
    margin-left: -1.5rem;
  }
  .summary-table.--mobile-full-width .summary-table__wrapper {
    min-width: 100%;
    max-width: 100%;
    padding-right: 0;
    margin: 0;
  }
  .download-link.--small {
    height: auto;
    padding: 2rem 1.5rem;
    flex-wrap: wrap;
    width: calc(100% + 3rem);
    margin-left: -1.5rem;
  }
  .download-link__thumb {
    width: 5rem;
    height: 5rem;
    min-width: 5rem;
  }
  .download-link__title {
    line-height: 2.6rem;
    margin-bottom: 1rem;
  }
  .va-btn.--big {
    width: 20rem;
  }
}

@media (max-width: 768px) {
  .container-fluid {
    margin-left: 0;
    margin-right: 0;
  }
  .banner {
    padding: 0;
    display: flex;
    justify-content: space-between;
  }
  .banner__bg {
    padding-right: 10px;
    width: 50%;
  } 
  .banner__content {
    width: 140px;
  }
  .banner__title {
    font-weight: bold;
    line-height: 1 !important;
    font-size: 18px !important;
    width: 180px;
    text-wrap: wrap;
  }
  .banner__text {
    padding-right: 0px;
    margin-top: 20px;
    width: 140px;
    font-size: 14px;
  }
  .breadcrumb {
    left: 2rem;
  }
  .breadcrumb__link {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/presysDetail.vue